import { POPUPS_ENABLED_ID } from "../common/constants";
import { hidePopup } from "../common/popup";
import { getLocalizedText } from "../common/translations";
import ControlBase, { IControlBaseOptions } from "./controlBase";

interface ISettingsControlOptions extends IControlBaseOptions {
    arrowVisibilityChanged: (visible:boolean) => void;
    ornamentVisibilityChanged: (visible:boolean) => void;
}

export default class SettingsControl extends ControlBase {
    ornamentsVisible: boolean;
    arrowsVisible: boolean;
    arrowVisibilityHandler: (visible:boolean) => void;
    ornamentVisibilityHandler: (visible:boolean) => void;

    constructor(options: ISettingsControlOptions) {
        let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        // Bootstrap ikona Gear https://icons.getbootstrap.com/icons/gear/
        svg.innerHTML = `<path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z"/>
            <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z"/>`;
        svg.setAttribute("width", "24px");
        svg.setAttribute("height", "24px");
        svg.setAttribute("viewBox", "0 0 16 16");
        options.symbol = svg;
        options.collapsible = true;
        options.tooltipText = getLocalizedText("controlTools");
        super(options);

        let div = document.createElement("div");
        this.generateCheckBox("togglePopups", getLocalizedText("settingShowPreview"), true, this.togglePopups.bind(this), div);
        this.collapsibleContent.appendChild(div);

        div = document.createElement("div");
        this.generateCheckBox("toggleArrows", getLocalizedText("settingShowArrows"), false, this.toggleArrows.bind(this), div);
        this.arrowsVisible = false;
        this.collapsibleContent.appendChild(div);

        div = document.createElement("div");
        this.generateCheckBox("toggleOrnaments", getLocalizedText("settingShowOrnaments"), true, this.toggleOrnaments.bind(this), div);
        this.ornamentsVisible = true;
        this.collapsibleContent.appendChild(div);

        this.arrowVisibilityHandler = options.arrowVisibilityChanged;
        this.ornamentVisibilityHandler = options.ornamentVisibilityChanged;
    }

    private togglePopups() {
        let currentState:boolean = this.getMap().get(POPUPS_ENABLED_ID);
        this.getMap().set(POPUPS_ENABLED_ID, !currentState);
        if (currentState) {
            hidePopup();
        }
    }

    private toggleArrows() {
        this.arrowsVisible = !this.arrowsVisible;
        if (this.arrowVisibilityHandler) {
            this.arrowVisibilityHandler(this.arrowsVisible);
        }
    }

    private toggleOrnaments() {
        this.ornamentsVisible = !this.ornamentsVisible;
        if (this.ornamentVisibilityHandler) {
            this.ornamentVisibilityHandler(this.ornamentsVisible);
        }
    }
}